// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ok-cancel-buttons_buttons__3Bl_u","cancel_button":"ok-cancel-buttons_cancel_button__3DQ6B"};